import { Customer, PointTransaction } from '@api/Customers/Customer';
import CustomerServ, { NewCustomerData, PaginatedQueryParams } from '@api/Customers/CustomerServ';
import { QueryDocumentSnapshot } from 'firebase/firestore';

class CustomerService {
    saveCustomer = async (newCustomerData: NewCustomerData): Promise<Customer> => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await CustomerServ.saveCustomer(newCustomerData);
                resolve(response);
            } catch (error) {
                reject(error);
            }
        });
    };
    getCustomers = async (branchOfficeId?: string): Promise<Customer[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const customers = await CustomerServ.getCustomers(branchOfficeId);
                resolve(customers);
            } catch (error) {
                reject('Error getting customers: ' + error);
            }
        });
    };

    getCustomersPaginated(
        params: PaginatedQueryParams
    ): Promise<{ data: Customer[]; count: number; lastVisible?: QueryDocumentSnapshot }> {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await CustomerServ.getCustomersPaginated(params);
                resolve(data);
            } catch (error) {
                reject('Error getting customers paginated: ' + error);
            }
        });
    }

    getCustomer = async (customerId: string): Promise<Customer> => {
        return new Promise(async (resolve, reject) => {
            try {
                const customer = await CustomerServ.getCustomer(customerId);
                resolve(customer);
            } catch (error) {
                reject('Error getting customer: ' + error);
            }
        });
    };

    getCustomerByPhone = async (phone: string): Promise<Customer | undefined> => {
        return new Promise(async (resolve, reject) => {
            try {
                const customer = await CustomerServ.getCustomerByPhone(phone);
                resolve(customer);
            } catch (error) {
                reject(error);
            }
        });
    };

    deleteCustomer = (customerId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await CustomerServ.deleteCustomer(customerId);
                resolve();
            } catch (error) {
                reject('Error deleting customer: ' + error);
            }
        });
    };

    addPoints = (customerId: string, points: number): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await CustomerServ.addPoints(customerId, points);
                resolve();
            } catch (error) {
                reject('Error deleting customer: ' + error);
            }
        });
    };

    correctUserPointsBasedOnOrders = (customerId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                const customer = await this.getCustomer(customerId);
                await CustomerServ.correctUsersPointsBasedOnOrders([customer]);
                resolve();
            } catch (error) {
                reject('correctUserPointsBasedOnOrders: ' + error);
            }
        });
    };

    deleteTransaction = (userId: string, transactionToDelete: PointTransaction): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await CustomerServ.deleteTransaction(userId, transactionToDelete);
                resolve();
            } catch (error) {
                reject('Error deleting customer transaction: ' + error);
            }
        });
    };
}

export default CustomerService;
